module.exports = __webpack_public_path__ + "static/media/search-btn.c40404b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/search-btn.svg
// module id = 811
// module chunks = 0